import { useIntl } from 'react-intl';
import { StatusBadge, type StatusBadgeTone } from '@immo/ui-kit';
import type { EmailLogStatus } from '@immo/api-contract';
import { useTranslations } from '@/i18n/use-translations';

const TONES: Record<EmailLogStatus, StatusBadgeTone> = {
  SENT: 'neutral',
  DELIVERED: 'success',
  BOUNCED: 'danger',
  COMPLAINED: 'warning',
  FAILED: 'danger',
};

type EmailStatusCellProps = {
  readonly status: EmailLogStatus;
  readonly statusAt: string | null;
  readonly failureReason: string | null;
};

export function EmailStatusCell({ status, statusAt, failureReason }: EmailStatusCellProps) {
  const t = useTranslations('pages.admin.email-log');
  const intl = useIntl();

  return (
    <div className="flex min-w-0 flex-col items-start gap-1">
      <StatusBadge tone={TONES[status]} size="sm" label={t(`statuses.${status}`)} />
      {status === 'FAILED' && failureReason !== null && (
        <span className="max-w-full truncate font-mono text-sm text-text-tertiary" title={failureReason}>
          {failureReason}
        </span>
      )}
      {statusAt !== null && (
        <span className="text-sm text-text-tertiary">
          {intl.formatDate(statusAt, { dateStyle: 'short', timeStyle: 'short' })}
        </span>
      )}
    </div>
  );
}
